import useClevertapForSrp from "@/src/hooks/analytics/clevertap/srp"
import { useAIFeatureEnableManager } from "@/src/hooks/AIFeatureEnableManager"
import { selectSRPFloatingAIChatEnabled, setSRPFloatingAIChatEnabled } from "@/src/redux/slices/aiFeatureSlice"
import { useAppDispatch, useAppSelector } from "@/src/redux/store"
import { AI_ACTION, AI_EVENT_NAME } from "@/src/utils/analytics/ai/aiEvents"
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome'
import { alpha, Box, Chip, Stack, Typography } from "@mui/material"
import { useTheme } from "@mui/material/styles"
import { useTranslations } from "next-intl"
import { getAIModeToggleTheme } from "../../home/AISearch/AIModeToggleHome"

export const ToggleSRPFloatingAIChatDesktop = () => {
    const t = useTranslations('common')
    const dispatch = useAppDispatch()
    const { srpSmartFilterSort } = useAIFeatureEnableManager()
    const srpFloatingAIChatEnabled = useAppSelector(selectSRPFloatingAIChatEnabled)
    const { triggerSrpAIEvent } = useClevertapForSrp()
    const { palette } = useTheme()
    if (!srpSmartFilterSort || srpFloatingAIChatEnabled) return null

    const handleOpenAIChat = () => {
        triggerSrpAIEvent(AI_EVENT_NAME.UI_ACTION, {
            action_name: AI_ACTION.SRP_OPEN_CHAT,
            action_type: 'mode_toggle',
            action_value: 'open',
            ai_layout: 'desktop'
        })
        // Onboarding is no longer auto-opened here; it opens only via the info button inside the chat.
        dispatch(setSRPFloatingAIChatEnabled({ enabled: true }))
    }
    const brandTheme = getAIModeToggleTheme(palette)
    return (
        <Stack
            component="button"
            type="button"
            aria-label={t('aiMode')}
            sx={{
                position: 'relative',
                zIndex: 1,
                display: 'inline-flex',
                alignItems: 'center',
                direction: 'row',
                p: 1,
                borderRadius: 1,
                cursor: 'pointer',
                border: 'none',
                outline: 'none',
                color: 'neutral.white',
                minWidth: 140,
                justifyContent: 'center',
                userSelect: 'none',
                background: brandTheme.gradient,
                boxShadow: 3,
                transition: 'transform .14s ease, box-shadow .24s ease, filter .24s ease',

            }}
            direction="row"
            spacing={0.85}
            onClick={handleOpenAIChat}
        >
            <Box
                sx={{
                    position: 'relative',
                    display: 'inline-flex',
                    '& .sparkle': {
                        animation: 'aiSpin 2.4s linear infinite'
                    },
                    '@keyframes aiSpin': {
                        '0%': { transform: 'rotate(0deg) scale(1)' },
                        '50%': { transform: 'rotate(180deg) scale(1.15)' },
                        '100%': { transform: 'rotate(360deg) scale(1)' }
                    }
                }}
            >
                <AutoAwesomeIcon className="sparkle" sx={{ fontSize: 18 }} />
            </Box>
            <Typography sx={{ fontWeight: 700, fontSize: 14.5, letterSpacing: 0.2 }}>
                {t('aiMode')}
            </Typography>
            <Chip
                label={t('beta')}
                size="small"
                sx={{
                    height: 18,
                    fontSize: 9.5,
                    fontWeight: 800,
                    letterSpacing: 0.7,
                    color: 'neutral.white',
                    bgcolor: 'transparent',
                    border: `1.5px solid ${alpha(palette.neutral.white, 0.85)}`,
                    transition: 'all .3s ease',
                    '& .MuiChip-label': { px: 0.7 }
                }}
            />
        </Stack>
    )
}
